import { render, staticRenderFns } from "./Act.vue?vue&type=template&id=31bfbe3a&scoped=true"
import script from "./Act.vue?vue&type=script&lang=js"
export * from "./Act.vue?vue&type=script&lang=js"
import style0 from "./Act.vue?vue&type=style&index=0&id=31bfbe3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bfbe3a",
  null
  
)

export default component.exports